import { Fragment } from 'react'

import { MethodInfoBlock, methodInfoStyles } from '@/core/components/MethodInfoBlock'
import { TypeLink } from '@/core/components/TypeLink'
import type { ParameterData, TypeUsage } from '@/core/types/library.type'

interface MethodSignatureProps {
  name: string
  returns?: string
  returnTypeUsage?: TypeUsage
  parameters: ParameterData[]
}

export function MethodSignature({ name, returns, returnTypeUsage, parameters }: MethodSignatureProps) {
  return (
    <MethodInfoBlock title="Method signature" variant="row">
      <span className={methodInfoStyles.parameterWrapper}>
        <TypeLink typeName={returns} typeUsage={returnTypeUsage} className={methodInfoStyles.valueType} />
        <span className={methodInfoStyles.space} />
      </span>
      {name}(
      <span className={methodInfoStyles.space} />
      {parameters.map((parameter, index) => (
        <Fragment key={parameter.name}>
          {index !== 0 && (
            <>
              ,
              <span className={methodInfoStyles.space} />
            </>
          )}
          <span className={methodInfoStyles.parameterWrapper}>
            <TypeLink typeName={parameter.type} typeUsage={parameter.typeUsage} />
            <span className={methodInfoStyles.space} />
            {parameter.name}
          </span>
        </Fragment>
      ))}
      )
    </MethodInfoBlock>
  )
}
